import { AutoSuggestItem } from "dora-shared";

const LOOKUP_ATTEMPTS = 3;

export class PlaceLookupError extends Error {
  constructor(public readonly cause: unknown) {
    super("Place lookup failed");
    this.name = "PlaceLookupError";
  }
}

// Google place details occasionally answers with a non-OK status for a place
// that resolves fine moments later, so retry before giving up. Each failed
// attempt is already reported to the backend by the search service's onError.
export const lookupWithRetries = async (item: AutoSuggestItem) => {
  for (let attempt = 1; ; attempt++) {
    try {
      return await item.lookup();
    } catch (err) {
      if (attempt >= LOOKUP_ATTEMPTS) {
        throw new PlaceLookupError(err);
      }
    }
  }
};
